import React from 'react'
import Landing from '../routes/landings/Kitchen'

const Kitchen = () => {
  return <Landing />
}

export default Kitchen
